import { render, staticRenderFns } from "./WebhookManager.vue?vue&type=template&id=ec747634&"
import script from "./WebhookManager.vue?vue&type=script&lang=ts&"
export * from "./WebhookManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports